import React from 'react'
import { Box, Container, Divider } from 'pcln-design-system'
import HOTELS_DEAL_MODULE_CONTENT from './constants'
import ScrollableDealModule from '../../ScrollableDealModule'

const HotelsDealModules = () => (
  <Box>
    <Container maxWidth={1280}>
      <Box px={3} pb={5} pt={4}>
        <ScrollableDealModule
          content={HOTELS_DEAL_MODULE_CONTENT}
          isUsingNavArrows={false}
          handleNavOnClick={(href: string) => window.open(href)}
          isUsingPriceType={false}
          isUsingPricePrefix
          isOpaque={false}
        />
      </Box>
    </Container>
    <Divider m={0} />
  </Box>
)

export default HotelsDealModules
